import React from 'react';
import CustomFirstNameCell from '../CustomFirstNameCell';

const FirstNameCell = () => ({
    field: 'first_name',
    headerName: 'First name',
    width: 120,
    minWidth: 80,
    editable: true,
    hideable: false,
    align: 'left',
    renderCell: (params) => <CustomFirstNameCell params={params} />
});

export default FirstNameCell;